module.exports = __webpack_public_path__ + "img/digitalIllustrate.6be535d0.jpg";